type MinimizeIconProps = {
  className?: string;
};
const MinimizeIcon = (props: MinimizeIconProps) => (
  <svg
    className={props.className !== undefined ? props.className : ""}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.60903 17.3913C2.53216 17.3144 2.48897 17.2101 2.48897 17.1014C2.48897 16.9927 2.53216 16.8884 2.60903 16.8116L7.8996 11.521L4.25153 11.5216C4.14268 11.5216 4.03828 11.4783 3.96131 11.4013C3.88434 11.3244 3.8411 11.22 3.8411 11.1111C3.8411 11.0023 3.88434 10.8979 3.96131 10.8209C4.03828 10.7439 4.14268 10.7007 4.25153 10.7007L8.88916 10.7007C8.9971 10.7008 9.10063 10.7435 9.17727 10.8195L9.18075 10.823C9.25437 10.8966 9.29901 10.9992 9.29901 11.1105L9.29901 15.7482C9.29909 15.857 9.25595 15.9613 9.17909 16.0383C9.10223 16.1153 8.99793 16.1585 8.88916 16.1586C8.78038 16.1587 8.67603 16.1156 8.59906 16.0387C8.52209 15.9618 8.47881 15.8575 8.47873 15.7488L8.47931 12.1007L3.18874 17.3913C3.11186 17.4681 3.0076 17.5113 2.89889 17.5113C2.79017 17.5113 2.68591 17.4681 2.60903 17.3913Z"
      fill="#757575"
    />
    <path
      d="M17.391 2.60873C17.4678 2.68561 17.511 2.78987 17.511 2.89859C17.511 3.0073 17.4678 3.11156 17.391 3.18844L12.1004 8.47903L15.7485 8.47845C15.8573 8.47845 15.9617 8.52169 16.0387 8.59866C16.1157 8.67563 16.1589 8.78002 16.1589 8.88888C16.1589 8.99773 16.1157 9.10213 16.0387 9.1791C15.9617 9.25607 15.8573 9.29931 15.7485 9.29931L11.1108 9.29931C11.0029 9.29917 10.8994 9.25647 10.8227 9.18047L10.8193 9.17699C10.7456 9.10337 10.701 9.00076 10.701 8.88946L10.701 4.25181C10.7009 4.14304 10.7441 4.03868 10.8209 3.96171C10.8978 3.88474 11.0021 3.84146 11.1108 3.84138C11.2196 3.8413 11.324 3.88444 11.4009 3.9613C11.4779 4.03817 11.5212 4.14246 11.5213 4.25123L11.5207 7.89932L16.8113 2.60873C16.8881 2.53186 16.9924 2.48867 17.1011 2.48867C17.2098 2.48867 17.3141 2.53186 17.391 2.60873Z"
      fill="#757575"
    />
  </svg>
);

export default MinimizeIcon;
